/**
 * Remembers a dismissed "Updates applied" notice for one exact template + update
 * list (monday 12868136019), so reopening an unchanged, unsaved template doesn't
 * show the same notice again. New content or new updates produce a new key.
 */
const STORAGE_KEY = 'bay-email-reconciliation-dismissed';
const MAX_ENTRIES = 50;

// djb2 - short and stable; a collision can only hide a notice, never touch data.
function hashString(value: string) {
	let hash = 5381;
	for (let i = 0; i < value.length; i++) hash = ((hash << 5) + hash + value.charCodeAt(i)) | 0;
	return (hash >>> 0).toString(36);
}

export function getDismissKey(content: unknown, upgradedBlocks: string[]): string {
	if (!content || !upgradedBlocks.length) return '';
	try {
		return hashString(JSON.stringify(content) + '|' + [...upgradedBlocks].sort().join(','));
	} catch {
		return '';
	}
}

function readMap(): string[] {
	try {
		const parsed = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '[]');
		return Array.isArray(parsed) ? parsed : [];
	} catch {
		return [];
	}
}

export function isDismissed(key: string): boolean {
	return Boolean(key) && readMap().includes(key);
}

export function rememberDismissed(key: string): void {
	if (!key) return;
	try {
		const next = [key, ...readMap().filter(entry => entry !== key)].slice(0, MAX_ENTRIES);
		window.localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
	} catch {
		// Blocked storage: the ✕ still hides it for this session.
	}
}
